import { __rest } from '../../../../../../_virtual/_tslib.js';
import React from 'react';
import { StyledNavbarBadge } from './NavbarBadge.styles.js';

const NavbarBadge = (_a) => {
    var { children, isDark = false } = _a, props = __rest(_a, ["children", "isDark"]);
    return (React.createElement(StyledNavbarBadge, Object.assign({ "$isDark": isDark }, props),
        React.createElement(React.Fragment, null, children)));
};
NavbarBadge.displayName = 'NavbarBadge';

export { NavbarBadge as default };
//# sourceMappingURL=NavbarBadge.js.map
